const ACCOUNT_MANAGEMENT = 'iaso_account_management';
const COMPLETENESS = 'iaso_completeness';
const COMPLETENESS_STATS = 'iaso_completeness_stats';
const DATA_DEVICES = 'iaso_data_devices';
const DATA_TASKS = 'iaso_data_tasks';
const ENTITIES = 'iaso_entities';
const ENTITY_TYPE_WRITE = 'iaso_entity_type_write';
const ENTITIES_DUPLICATE_READ = 'iaso_entity_duplicates_read';
const ENTITIES_DUPLICATE_WRITE = 'iaso_entity_duplicates_write';
const FORMS = 'iaso_forms';
const FORMS_STATS = 'iaso_forms_stats';
const LINKS = 'iaso_links';
const MAPPINGS = 'iaso_mappings';
const MOBILE_APP_OFFLINE_SETUP = 'iaso_mobile_app_offline_setup';
const ORG_UNIT_GROUPS = 'iaso_org_unit_groups';
const ORG_UNIT_TYPES = 'iaso_org_unit_types';
const ORG_UNITS = 'iaso_org_units';
const ORG_UNITS_READ = 'iaso_org_units_read';
const ORG_UNITS_HISTORY = 'iaso_org_units_history';
const PAGES = 'iaso_pages';
const PAGE_WRITE = 'iaso_page_write';
const PLANNING_READ = 'iaso_planning_read';
const PLANNING_WRITE = 'iaso_planning_write';
const POLIO = 'iaso_polio';
const POLIO_CONFIG = 'iaso_polio_config';
const POLIO_CHRONOGRAM = 'iaso_polio_chronogram';
const POLIO_CHRONOGRAM_RESTRICTED_WRITE =
    'iaso_polio_chronogram_restricted_write';
const POLIO_SUPPLY_CHAIN_READ = 'iaso_polio_vaccine_supply_chain_read';
const POLIO_SUPPLY_CHAIN_WRITE = 'iaso_polio_vaccine_supply_chain_write';
const POLIO_SUPPLY_CHAIN_READ_ONLY =
    'iaso_polio_vaccine_supply_chain_read_only';
const POLIO_VACCINE_STOCK_READ = 'iaso_polio_vaccine_stock_management_read';
const POLIO_VACCINE_STOCK_READ_ONLY =
    'iaso_polio_vaccine_stock_management_read_only';
const POLIO_VACCINE_STOCK_WRITE = 'iaso_polio_vaccine_stock_management_write';

const POLIO_VACCINE_STOCK_EARMARKS_NONADMIN =
    'iaso_polio_vaccine_stock_earmarks_nonadmin';
const POLIO_VACCINE_STOCK_EARMARKS_ADMIN =
    'iaso_polio_vaccine_stock_earmarks_admin';
const POLIO_VACCINE_STOCK_EARMARKS_READ_ONLY =
    'iaso_polio_vaccine_stock_earmarks_read_only';
const PROJECTS = 'iaso_projects';
const REGISTRY_WRITE = 'iaso_registry_write';
const REGISTRY_READ = 'iaso_registry_read';
const ORG_UNITS_CHANGE_REQUEST_REVIEW = 'iaso_org_unit_change_request_review';
const ORG_UNITS_CHANGE_REQUESTS_CONFIGURATION =
    'iaso_org_unit_change_request_configurations';
const SOURCES = 'iaso_sources';
const SOURCES_CAN_CHANGE_DEFAULT_VERSION =
    'iaso_sources_can_change_default_version';
const SOURCE_WRITE = 'iaso_write_sources';
const STORAGES = 'iaso_storages';
const SUBMISSIONS = 'iaso_submissions';
const SUBMISSIONS_UPDATE = 'iaso_update_submission';
const TEAMS = 'iaso_teams';
const USER_ROLES = 'iaso_user_roles';
const USERS_ADMIN = 'iaso_users';
const USERS_MANAGEMENT = 'iaso_users_managed';
const WORKFLOWS = 'iaso_workflows';
const MODULES = 'iaso_modules';
const POLIO_NOTIFICATIONS = 'iaso_polio_notifications';
const PAYMENTS = 'iaso_payments';
const STOCK_MANAGEMENT = 'iaso_stock_management';
const METRIC_TYPES = 'iaso_metric_types';
const VALIDATION_WORKFLOWS = 'iaso_validation_workflows';

export {
    ACCOUNT_MANAGEMENT,
    COMPLETENESS,
    COMPLETENESS_STATS,
    DATA_DEVICES,
    DATA_TASKS,
    ENTITIES,
    ENTITIES_DUPLICATE_READ,
    ENTITIES_DUPLICATE_WRITE,
    ENTITY_TYPE_WRITE,
    FORMS,
    FORMS_STATS,
    LINKS,
    MAPPINGS,
    METRIC_TYPES,
    MOBILE_APP_OFFLINE_SETUP,
    MODULES,
    ORG_UNITS,
    ORG_UNITS_CHANGE_REQUESTS_CONFIGURATION,
    ORG_UNITS_CHANGE_REQUEST_REVIEW,
    ORG_UNITS_READ,
    ORG_UNITS_HISTORY,
    ORG_UNIT_GROUPS,
    ORG_UNIT_TYPES,
    PAGES,
    PAGE_WRITE,
    PAYMENTS,
    PLANNING_READ,
    PLANNING_WRITE,
    POLIO,
    POLIO_CHRONOGRAM,
    POLIO_CHRONOGRAM_RESTRICTED_WRITE,
    POLIO_CONFIG,
    POLIO_NOTIFICATIONS,
    POLIO_SUPPLY_CHAIN_READ,
    POLIO_SUPPLY_CHAIN_READ_ONLY,
    POLIO_SUPPLY_CHAIN_WRITE,
    POLIO_VACCINE_STOCK_READ,
    POLIO_VACCINE_STOCK_READ_ONLY,
    POLIO_VACCINE_STOCK_WRITE,
    POLIO_VACCINE_STOCK_EARMARKS_NONADMIN,
    POLIO_VACCINE_STOCK_EARMARKS_ADMIN,
    POLIO_VACCINE_STOCK_EARMARKS_READ_ONLY,
    PROJECTS,
    REGISTRY_READ,
    REGISTRY_WRITE,
    SOURCES,
    SOURCES_CAN_CHANGE_DEFAULT_VERSION,
    SOURCE_WRITE,
    STOCK_MANAGEMENT,
    STORAGES,
    SUBMISSIONS,
    SUBMISSIONS_UPDATE,
    TEAMS,
    USERS_ADMIN,
    USERS_MANAGEMENT,
    USER_ROLES,
    VALIDATION_WORKFLOWS,
    WORKFLOWS,
};
